import React, { Component } from "react";
import moment from "moment";
import underscore from "underscore";
import {
  Row,
  Col,
  Input,
  Radio,
  Button,
  Modal,
  Select,
  Form,
  Table,
  Pagination,
  DatePicker,
  Icon,
  Spin,
  Popconfirm,
} from "antd";
import { api, app } from "../../app";
import VerificationAdd from "./Verification/verificationAdd";
import utils from "../../utils";
import Highlighter from "react-highlight-words";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

function getIdentityList(tj) {
  const identityList = [
    { text: "义警", value: "义警" },
    { text: "见习义警", value: "见习义警" },
    { text: "平安志愿者", value: "平安志愿者" },
    { text: "离队", value: "离队" },
    { text: "清队", value: "清队" },
  ];
  if (tj) {
    return (underscore.find(identityList, (iden) => iden.text === tj) || {})
      .value;
  }
  return identityList;
}

class ProTeamManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_name: "", // 搜索名称(vname,bsrno)
      search_value: "", // 搜索值
      page: 1, // 分页
      ahegp: 20, // 默认20条一页
      team_loading: true,
      rights: app.getData("rights"),
      rights_duizhang: app.getData("rights_duizhang"),
      all_team: [],
      teamList: [],
      playerList: [],
      select_team: {},
      edit_modal: false,
      data_loading: true,
      load_index: 0,
      edit_index: -1,
      authorityList: [],
      posttionList: [],
      searchText: "",
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  /**
   * 权限数据
   * @returns {Promise<any>}
   */
  authorityData = async (page) => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    if (flag === 1) {
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  authorityData2 = async () => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    // if (data.length > 0) {
    //     data.forEach((e, k) => {
    //         if (e.multeamright_name === null) {
    //             e.multeamright_name = e.rights;
    //         }
    //     })
    // }
    if (flag === 1) {
      // console.log(data);
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.getteamList();
    await this.teamListData();
    const innerHeight = document.body.offsetHeight,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    await this.setData({ table_height });
    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
    this._isMounted = false;
  }

  /**
   * 人员列表
   */
  teamListData = async (load_index) => {
    let {team_id} = this.state
    await this.setData({ load_index, data_loading: true });
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      limit: this.state.ahegp || 20,
      page: this.state.page || 1,
      version_id: api.version_id,
      team_id:team_id,
      name: this.state.search_value, // 搜索值
    };
    let { flag, data, msg, total } = await app.post(
      api.coinAdminListManage,
      params
    );
    if (flag === 1) {
      data.forEach((item) => {
        item.tpList = item.teampositionname
          ? item.teampositionname.split(",")
          : [];
      });
    } else {
      data = [];
      app.alert(msg, "error");
    }
    const state = { total, playerList: utils.addArrayKey(data || []) };
    if (this.state.load_index === load_index) {
      state.data_loading = false;
    }
    await this.setData(state);
  };

  /**
   * 显示添加对话框
   * @param add_modal
   */
  handleOpenAddModal = async (id) => {
    // await this.authorityData2();
    setTimeout(() => {
      const { playerList } = this.state,
        index = playerList.findIndex((p) => p.volunteer_id === id);
      this.setData({ edit_index: index, edit_modal: true });
    }, 500);
  };

  /**
   * 隐藏添加对话框
   * @param add_modal
   */
  handleCloseAddModal = async () => {
    await this.setData({ edit_modal: false });
    this.props.form.resetFields();
  };

  /**
   * 职务列表
   **/
  PosttionData = async () => {
    const params = {
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.UserStateList, params);
    if (flag === 1) {
      const rights = app.getData("rights");
      // console.log(rights);
      let posttionList = data;
      if (rights === 1) {
        posttionList.forEach((posttion) => {
          posttion.permiss = null;
        });
      } else if (rights === 2) {
        posttionList.forEach((posttion) => {
          if (posttion.permiss === "province") {
            posttion.permiss = null;
          }
        });
      }
      await this.setData({ posttionList });
    } else {
      app.alert(msg, "error");
    }
    // await this.authorityData()
  };

  /**
   * 提交
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { select_team } = this.state,
          params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
          };
        values.multeamright_id = values.multeamright_id
          ? values.multeamright_id.join(",")
          : "";
        values.team_position_id = values.team_position_id
          ? values.team_position_id.join(",")
          : "";
        if (values.indate) values.indate = values.indate.format("YYYY-MM-DD");
        values = Object.assign(values, params);
        const { flag, msg } = await app.post(api.UserInfoAlter, values);
        if (flag === 1) {
          this.teamListData(select_team, this.state.load_index);
          this.handleCloseAddModal();
          app.alert("修改成功", "success");
        } else {
          app.alert(msg, "error");
        }
        await this.setData({ edit_loading: false });
      }
    });
  };

  onWindowResize = (e) => {
    const { innerHeight } = e.target,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    this.setData({ table_height });
  };

  /**
   *
   * @constructor
   */
  OpenAddPlayerModal = () => {
    this.setData({ add_modal: true });
  };
  import = () => {};

  // 切换选项
  changeSelect = (e) => {
    // search_value
    if (e == "姓名") {
      this.setState({
        search_name: "vname",
      });
    } else {
      this.setState({
        search_name: "bsrno",
      });
    }
    // console.log(e);
  };

  // 监听输入
  inputMotify = (e) => {
    // search_value
    this.setState({
      search_value: e.target.value,
    });
    // console.log(e.target.value);
  };

  // 去搜索
  toSearchBtn = () => {
    this.setData({ page: 1 });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  CloseAddPlayerModal = async (flag) => {
    await this.setData({ add_modal: false, add_flush: true });
    await this.setData({ add_flush: false });
    // await this.handleReportsData();
    const { select_team, load_index } = this.state;
    await this.teamListData(select_team, load_index);
  };

  /**
   * 表格搜索
   * @param dataIndex
   * @returns {{filterDropdown: (function({setSelectedKeys: *, selectedKeys?: *, confirm?: *, clearFilters?: *}): *), filterIcon: (function(*): *), onFilter: (function(*, *): boolean), onFilterDropdownVisibleChange: onFilterDropdownVisibleChange, render: (function(*): *)}}
   */
  getColumnSearchProps = (dataIndex, search_name) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`搜索 ${search_name}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleTableSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          onClick={() => this.handleTableReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          重置
        </Button>
        <Button
          type="primary"
          onClick={() => this.handleTableSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginLeft: 8 }}
        >
          搜索
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <Icon type="search" style={{ color: "#fff" }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  /**
   * 取消
   * @param id
   */
  handleDelete = async (indexno_coin, coin_admin) => {
    const params = {
      account: app.getData("account"),
      indexno: app.getData("indexno"),
      indexno_coin: indexno_coin,
      coin_admin: coin_admin,
    };
    let { flag, data, msg } = await app.post(api.delCoinAdmin, params);
    if (flag === 1) {
      await this.teamListData();
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 列表搜索
   * @param selectedKeys
   * @param confirm
   */
  handleTableSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  /**
   * 列表搜索重置
   * @param clearFilters
   */
  handleTableReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // 队伍列表
  getteamList = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.getTeamName, params);
    if (flag === 1) {
      this.setData({ teamList: data });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  // 改变页码
  changeAhegp = (q, r) => {
    this.setState({ ahegp: r, page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  // 改变页码
  changeAhegp2 = (q) => {
    this.setState({ page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  render() {
    // console.log('10'.indexOf(this.state.rights_duizhang) + "==" + '1'.indexOf(this.state.rights));

    let {
        loading,
        data_loading,
        edit_index,
        add_modal,
        edit_modal,
        edit_loading,
        playerList,
        select_team,
        posttionList,
        teamList,
        rights,
        rights_duizhang,
        add_flush,
        total,
      } = this.state,
      columns = [
        {
          title: "序号",
          dataIndex: "xuhao",
          key: "xuhao",
          width: 50,
          // fixed: "left",
          render(text, record, index) {
            return <span>{index + 1}</span>;
          },
        },
        {
          title: "姓名",
          dataIndex: "vname",
          key: "vname",
          // fixed: "left",
          width: 130,
          // ...this.getColumnSearchProps("vname", "姓名"),
          //   width: '9%'
        },
        {
          title: "编号",
          dataIndex: "bsrno",
          key: "bsrno",
          // fixed: "left",
          width: 130,
          // ...this.getColumnSearchProps("vname", "姓名"),
          //   width: '9%'
        },
        {
          title: "性别",
          dataIndex: "sex",
          key: "sex",
          width: 120,
          render(text) {
            return <span>{text || "无"}</span>;
          },
          filters: [
            { text: "男", value: "男" },
            { text: "女", value: "女" },
          ],
          filterMultiple: false,
          filterIcon: (filtered) => (
            <Icon
              type="filter"
              theme="filled"
              style={{ color: filtered ? "#bfbfbf" : "#fff" }}
            />
          ),
          onFilter: (value, record) => record.sex == value,
          // width: '5%'
        },
        {
          title: "身份",
          dataIndex: "status_name",
          key: "status_name",
          width: 150,
          // width: '8%',
          filters: [
            { text: "正式队员", value: "正式队员" },
            { text: "队员", value: "队员" },
            { text: "预备队员", value: "预备队员" },
            { text: "认证志愿者", value: "认证志愿者" },
            { text: "志愿者", value: "志愿者" },
            { text: "离队", value: "离队" },
            { text: "清队", value: "清队" },
          ],
          filterMultiple: false,
          filterIcon: (filtered) => (
            <Icon
              type="filter"
              theme="filled"
              style={{ color: filtered ? "#bfbfbf" : "#fff" }}
            />
          ),
          onFilter: (value, record) => record.status_name === value,
          render(text) {
            return <span>{text || " - "}</span>;
          },
        },
        {
          title: "手机号",
          dataIndex: "mobile",
          key: "mobile",
          width: 160,
          render(text) {
            return <span>{text || " 无 "}</span>;
          },
        },
        {
          title: "核销队伍",
          dataIndex: "teamname",
          key: "teamname",
          // fixed: "left",
          width: 180,
          // ...this.getColumnSearchProps("vname", "姓名"),
          //   width: '9%'
        },
        {
          title: "操作",
          dataIndex: "indexno_coin",
          key: "indexno_coin",
          // fixed: "right",
          width: 120,
          render: (indexno_coin, { coin_admin }) => {
            return (
              <Popconfirm
                placement="bottom"
                title="确定取消吗？"
                cancelText="取消"
                okText="确定"
                onConfirm={() => this.handleDelete(indexno_coin, coin_admin)}
              >
                <div>
                  <Button size="small" type="danger" style={{ marginTop: 10 }}>
                    取消
                  </Button>
                </div>
              </Popconfirm>
            );
          },
        },
      ],
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      { getFieldDecorator, getFieldValue } = this.props.form,
      table_height = 600,
      identityList = getIdentityList(),
      edit_info = playerList[edit_index] || {},
      identity = getFieldValue("identity");
    let reasonItem = null,
      notLK = true,
      { authorityList } = this.state;
    authorityList = app.objectArrayAdd(
      authorityList,
      edit_info.rights,
      (obj) => {
        if (
          authorityList.findIndex(
            (author) => author.multeamright_id === obj.id
          ) === -1
        ) {
          return {
            multeamright_id: obj.id,
            multeamright_name: obj.multeamright,
            disabled: true,
          };
        }
        return null;
      }
    );
    // console.log(this.state.authorityList);

    // this.state.authorityList.forEach((e, k) => {
    //     if (e.multeamright_name == '粤all') {
    //         console.log("有值，位置：" + k);
    //     }
    // })

    if (identity === "4" || identity === "5") {
      notLK = false;
      reasonItem = (
        <FormItem {...formItemLayout} label="身份修改原因">
          {getFieldDecorator("leave_reason", {
            rules: [
              {
                required: true,
                message: "请输入离队/清退 原因！",
              },
            ],
          })(<Input.TextArea placeholder="请填写离队/清退 原因" rows={4} />)}
        </FormItem>
      );
    }
    let rights_edit;
    if (
      this.state.rights == "1" ||
      this.state.rights == "2" ||
      this.state.rights_duizhang == "10"
    ) {
      rights_edit = false;
    } else {
      rights_edit = true;
    }

    const title_box = (e) => {
      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItem: "center",
          }}
        >
          <div>编辑队员信息</div>
          <div style={{ fontWeight: "600" }}>{e || ""}</div>
          <div style={{ width: "100px", height: "1px" }}></div>
        </div>
      );
    };

    function showTotal(total) {
      return `总数：${total}条`;
    }

    return (
      <div className="team-editor pro-team" style={{ padding: 0 }}>
        <Row
          className="content"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Col span={23} className="team-table">
            <Table
              className="ranks_table"
              title={() => {
                return (
                  <Row className="pro-table-title">
                    <Col
                      span={7}
                      style={{
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Input.Group compact>
                        <Select
                          style={{ width: 100 }}
                          defaultValue="姓名"
                          onChange={(e) => this.changeSelect(e)}
                        >
                          <Option value="姓名">姓名</Option>
                        </Select>
                        <Input.Search
                          onSearch={() => this.toSearchBtn()}
                          onChange={(e) => this.inputMotify(e)}
                          style={{ width: 240, marginRight: 32 }}
                          enterButton="搜索"
                        />
                      </Input.Group>

                      {/* <Button type="primary"onClick={() => this.import()}>导入队员</Button> */}
                    </Col>
                    <Col span={11}>
                      <div style={{ marginRight: "10px" }}>
                        <span>选择队伍：</span>
                        <Select
                          defaultValue="-1"
                          style={{ width: 200 }}
                          onChange={async (value) => {
                            await this.setData({ team_id: value });
                            await this.teamListData();
                          }}
                        >
                          <Option value="-1">全部</Option>
                          {teamList.length > 0 &&
                            teamList.map((item, index) => (
                              <Option key={item.team_id} value={item.team_id}>
                                {item.teamname}
                              </Option>
                            ))}
                        </Select>
                      </div>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <Button
                        style={{ marginRight: "15px" }}
                        type="primary"
                        onClick={() => this.OpenAddPlayerModal()}
                      >
                        添加核销员
                      </Button>
                    </Col>
                  </Row>
                );
              }}
              locale={app.tbLocale(loading)}
              columns={columns}
              dataSource={playerList}
              loading={data_loading}
              scroll={{ y: table_height, x: 1200 }}
              size="small"
              pagination={false}
              // pagination={{

              // }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                style={{ marginTop: 16 }}
                current={this.state.page}
                defaultCurrent={1}
                total={total}
                showTotal={showTotal}
                defaultPageSize={20}
                pageSizeOptions={["20", "50", "100"]}
                showSizeChanger={true}
                size="default"
                onShowSizeChange={(e, a) => this.changeAhegp(e, a)}
                onChange={(e) => this.changeAhegp2(e)}
              />
            </div>
            <Modal
              visible={edit_modal}
              title={title_box(select_team.teamname || "队伍名称异常")}
              onCancel={this.handleCloseAddModal}
              footer={
                <Row type="flex" justify="center">
                  <Button
                    type="primary"
                    loading={edit_loading}
                    onClick={this.handleSubmit}
                  >
                    确定
                  </Button>
                </Row>
              }
              maskClosable={false}
              width={1200}
              className="edit-team-modal"
            >
              <Form>
                {getFieldDecorator("volunteer_id", {
                  initialValue: edit_info.volunteer_id,
                })(<Input type="hidden" />)}
                <FormItem {...formItemLayout} label="姓名">
                  {getFieldDecorator("name", {
                    rules: [
                      {
                        required: true,
                        message: "请输入队员姓名！",
                      },
                    ],
                    initialValue: edit_info.vname || "",
                  })(
                    <Input
                      placeholder="请填写队员姓名"
                      disabled={edit_info.ifhasrealname === "true"}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="身份证">
                  {getFieldDecorator("idno", {
                    rules: [{ required: true, message: "请填写身份证号！" }],
                    initialValue: edit_info.idno || "",
                  })(
                    <Input
                      placeholder="请填写身份证号"
                      max={18}
                      disabled={edit_info.ifhasrealname === "true"}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="身份">
                  {getFieldDecorator("identity", {
                    rules: [
                      {
                        required: true,
                        message: "请选择队员身份！",
                      },
                    ],
                    initialValue: edit_info.status_name
                      ? getIdentityList(edit_info.status_name.trim())
                      : "",
                  })(
                    <Select placeholder="请选择队员身份" style={{ width: 240 }}>
                      {identityList.map((iden, index) => {
                        return (
                          <Option key={index + 1} value={iden.value}>
                            {iden.text}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                  <span className="ant-form-text">
                    {edit_info.volunteer_state_audit}
                  </span>
                </FormItem>
                {reasonItem}
                <FormItem {...formItemLayout} label="手机号">
                  {getFieldDecorator("mobile", {
                    rules: [
                      {
                        required: true,
                        message: "请填写队员手机号！",
                      },
                    ],
                    initialValue: edit_info.mobile || "",
                  })(<Input placeholder="请填写队员手机号" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="管理权限">
                  {getFieldDecorator("multeamright_id", {
                    initialValue:
                      edit_info.rights && edit_info.rights.length > 0
                        ? edit_info.rights.map((r) => r.id)
                        : [],
                  })(
                    <Select
                      mode="multiple"
                      placeholder={
                        rights_edit ? "您不可以编辑权限" : "请选择队员权限"
                      }
                      optionFilterProp="children"
                      notFoundContent="无"
                      disabled={rights_edit}
                    >
                      {authorityList.map((authority, index) => {
                        return (
                          <Option
                            key={index + 1}
                            disabled={authority.disabled}
                            value={authority.multeamright_id}
                          >
                            {authority.multeamright_name}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="性别">
                  {getFieldDecorator("sex", {
                    initialValue: edit_info.sex || "",
                  })(
                    <RadioGroup
                      options={[
                        { label: "男", value: "男" },
                        { label: "女", value: "女" },
                      ]}
                    />
                  )}
                </FormItem>
              </Form>
            </Modal>
            <Modal
              visible={add_modal}
              title="添加人员"
              onCancel={this.CloseAddPlayerModal}
              footer={null}
              width={1200}
              bodyStyle={{ maxHeight: "calc(100vh - 200px)", overflow: "auto" }}
              maskClosable={false}
              destroyOnClose={true}
              className="edit-team-modal"
            >
              <VerificationAdd
                flush={add_flush}
                edit_id={"1"}
                onClose={this.CloseAddPlayerModal}
              />
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Form.create()(ProTeamManage);



// WEBPACK FOOTER //
// ./src/routes/grade/verification.jsx